export const SET_HISTORICO = "deca.SET_HISTORICO";
export const DELETE_HISTORICO = "deca.DELETE_HISTORICO";
export const MODAL_HISTORICO_CLOSE = "MODAL_HISTORICO_CLOSE";
export const MODAL_HISTORICO_OPEN = "MODAL_HISTORICO_OPEN";
export const ADD_SAGA_HISTORICO = "deca.SET_SAGA_HISTORICO";
export const ADD_HISTORICO = "deca.ADD_HISTORICO";
export const DELETE_SAGA_HISTORICO = "deca.DELETE_SAGA_HISTORICO";
